"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceSide = exports.DayCountBasisConvention = void 0;
var DayCountBasisConvention;
(function (DayCountBasisConvention) {
    DayCountBasisConvention["Dcb_30_360"] = "Dcb_30_360";
    DayCountBasisConvention["Dcb_30_360_US"] = "Dcb_30_360_US";
    DayCountBasisConvention["Dcb_30E_360_ISMA"] = "Dcb_30E_360_ISMA";
    DayCountBasisConvention["Dcb_30_360_ISDA"] = "Dcb_30_360_ISDA";
    DayCountBasisConvention["Dcb_30_365_ISDA"] = "Dcb_30_365_ISDA";
    DayCountBasisConvention["Dcb_30_Actual_ISDA"] = "Dcb_30_Actual_ISDA";
    DayCountBasisConvention["Dcb_30_360_German"] = "Dcb_30_360_German";
    DayCountBasisConvention["Dcb_30_365_German"] = "Dcb_30_365_German";
    DayCountBasisConvention["Dcb_30_Actual_German"] = "Dcb_30_Actual_German";
    DayCountBasisConvention["Dcb_30_Actual"] = "Dcb_30_Actual";
    DayCountBasisConvention["Dcb_Actual_360"] = "Dcb_Actual_360";
    DayCountBasisConvention["Dcb_Actual_364"] = "Dcb_Actual_364";
    DayCountBasisConvention["Dcb_Actual_365"] = "Dcb_Actual_365";
    DayCountBasisConvention["Dcb_Actual_Actual"] = "Dcb_Actual_Actual";
    DayCountBasisConvention["Dcb_Actual_Actual_ISDA"] = "Dcb_Actual_Actual_ISDA";
    DayCountBasisConvention["Dcb_Actual_Actual_AFB"] = "Dcb_Actual_Actual_AFB";
    DayCountBasisConvention["Dcb_WorkingDays_252"] = "Dcb_WorkingDays_252";
    DayCountBasisConvention["Dcb_Actual_365L"] = "Dcb_Actual_365L";
    DayCountBasisConvention["Dcb_ActualLeapDay_365"] = "Dcb_ActualLeapDay_365";
    DayCountBasisConvention["Dcb_ActualLeapDay_360"] = "Dcb_ActualLeapDay_360";
    DayCountBasisConvention["Dcb_Actual_36525"] = "Dcb_Actual_36525";
    DayCountBasisConvention["Dcb_Actual_365_CanadianConvention"] = "Dcb_Actual_365_CanadianConvention";
    DayCountBasisConvention["Dcb_Constant"] = "Dcb_Constant";
    DayCountBasisConvention["Dcb_Actual_365P"] = "Dcb_Actual_365P";
    DayCountBasisConvention["Dcb_30_365_Brazil"] = "Dcb_30_365_Brazil";
})(DayCountBasisConvention || (exports.DayCountBasisConvention = DayCountBasisConvention = {}));
var PriceSide;
(function (PriceSide) {
    PriceSide["Mid"] = "Mid";
    PriceSide["Bid"] = "Bid";
    PriceSide["Ask"] = "Ask";
    PriceSide["Last"] = "Last";
})(PriceSide || (exports.PriceSide = PriceSide = {}));
